import { useContext } from "react"
import { AR } from "../../../../types/enums";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext"
import PurchaseOrderInvoiceProducts from "./PurchaseOrderInvoiceProducts";
import PurchaseOrderNewInvoiceProducts from "./PurchaseOrderNewInvoiceProducts";

export default function InvoiceDetailsPanel() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<div className='dx-card wide-card'>
			<div className='grid-header'>Invoice Details</div>
			{
				order.details.activeARs.includes(AR.PODistributorToInvoice) ||
					order.details.activeARs.includes(AR.POServiceProviderToInvoice) ?
					<PurchaseOrderNewInvoiceProducts /> :
					<PurchaseOrderInvoiceProducts />
			}
		</div>
	)
}